import { FileData } from 'src/data-capture/hooks/file-uploads/types';

export type Fund = {
  id: string;
  name: string;
  type: string;
  pricePerUnit: number;
  code: string;
  amcPercentage: number;
  fundFiles: FundDocument[];
};

export type FundReportType = 'FUND_FACT_SHEET' | 'RISK_PROFILE' | 'OTHER';

export type FundDocument = {
  id: string;
  file: FileData;
  isLatest: boolean;
  reportType: FundReportType;
  reportDate: Date;
};

export const CompanyTabs = {
  funds: 'funds',
  providers: 'providers',
  templates: 'templates',
} as const;
